import { Component, OnInit } from "@angular/core";
import { NgbCalendar, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import * as data from "../data/dashboard/default";

@Component({
  selector: "app-widgets",
  templateUrl: "./widgets.component.html",
  styleUrls: ["./widgets.component.scss"],
})
export class WidgetsComponent implements OnInit {
  constructor(calendar: NgbCalendar) {}

  ngOnInit() {}

  // public purchase = data.purchase
  // public salesReturn = data.salesReturn
  // public sales = data.sales
  // public purchaseRate = data.purchaseRate
}
